import { useNavigate, useParams } from "react-router-dom";
import { CheckInDetailHeader } from "../components/common/checkInDetailHeader";
import { useCheckInDetail } from "../hooks/useCheckInDetail";
import { QrScannerButton } from "../components/checkInDetail/qrScannerButton";
import { CheckInDetailTable } from "../components/checkInDetail/checkInDetailTable";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { toast } from "react-toastify";

export function CheckInDetail() {
  const { artistId, eventId, rewardId } = useParams();
  const artistIdNum = Number(artistId) ?? 0;
  const eventIdNum = Number(eventId) ?? 0;
  const rewardIdNum = Number(rewardId) ?? 0;
  const { checkInDetail } = useCheckInDetail({
    artistId: artistIdNum,
    eventId: eventIdNum,
    rewardId: rewardIdNum,
  });
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (artistId && eventId && rewardId) {
    return (
      <div className={"flex flex-col h-full"}>
        <CheckInDetailHeader
          checkIn={checkInDetail}
          title={t("eventdetail_title")}
        ></CheckInDetailHeader>
        <div className={"flex-grow overflow-y-auto min-h-0"}>
          <QrScannerButton
            onClick={() => {
              const now = moment();
              if (
                now.isBetween(
                  checkInDetail?.ticketAvailablePeriod?.startAt,
                  checkInDetail?.ticketAvailablePeriod?.endAt,
                  "second",
                  "[)",
                )
              ) {
                navigate(
                  `/artists/${artistId}/events/${eventId}/rewards/${rewardId}/scanner`,
                );
              } else {
                toast.error(t("alert_msg_invalid"));
              }
            }}
          />
          {checkInDetail && (
            <CheckInDetailTable
              artistId={artistIdNum}
              checkIn={checkInDetail}
            />
          )}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}
